module.exports = __webpack_public_path__ + "img/czzn_050.26ce0bce.png";